import { oz } from '@weft/utils';

export const BILLING_CYCLE_INVOICE_TYPES = Object.freeze({
  REGULAR: 'regular',
  INSPECTION: 'inspection',
  OLD: 'old',
});

export const BillingCycleInvoiceTypeSchema = oz.nativeEnum(BILLING_CYCLE_INVOICE_TYPES).openapi('BillingCycleInvoiceType');

export type BillingCycleInvoiceType = oz.infer<typeof BillingCycleInvoiceTypeSchema>;